import React from "react";
import "../App.css";
import HappiestEmoji from "../assets/happiest.svg";
import HappyEmoji from "../assets/happy.svg";
import NeutralEmoji from "../assets/neutral.svg";
import SadEmoji from "../assets/sad.svg";
import SaddestEmoji from "../assets/saddest.svg";
import FeedbackEmoji from "./FeedbackEmoji";

class FeedbackMeter extends React.Component {
    render() {
        return <div className="Feedback-Meter">Happy with these suggestions?
            <div className="Feedback-Options">
                <FeedbackEmoji src={HappiestEmoji} name="happiest" meterName="feedback-meter" />
                <FeedbackEmoji src={HappyEmoji} name="happy" meterName="feedback-meter" />
                <FeedbackEmoji src={NeutralEmoji} name="neutral" meterName="feedback-meter" />
                <FeedbackEmoji src={SadEmoji} name="sad" meterName="feedback-meter" />
                <FeedbackEmoji src={SaddestEmoji} name="saddest" meterName="feedback-meter" />
            </div>
        </div>;
    }
}

export default FeedbackMeter;